var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[(_vm.outsideControl)?_c('span',{staticClass:"loading-box"},[_vm._v(" loading:"+_vm._s(_vm.percent)+"% ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }